import { Component, Inject, Input } from '@angular/core';

import { Router } from '@angular/router';

import { EnvironmentConfig } from '../../../config/environment.config';

@Component({
  selector: 'mom-header-with-logo-and-right-button',
  templateUrl: './header-with-logo-and-right-button.component.html',
  styleUrls: ['./header-with-logo-and-right-button.component.scss']
})
export class HeaderWithLogoAndRightButtonComponent {
  @Input() cssClass: string;

  logo = this.environment.logoPath;
  logoAltName = `${this.environment.appName} Logo`;

  constructor(@Inject('environment') private environment: EnvironmentConfig, private router: Router) {}
  goHome(): void {
    this.router.navigate(['home']);
  }
}
